/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useRef, useState, useEffect } from 'react';
import Alert from 'react-s-alert';
import ReCAPTCHA from "react-google-recaptcha";

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import PsychometricTestMainNavbar from '../psychometric/PsychometricTestMainNavbar';
import ContactUsImg from '../../assets/contactus.svg';
import PsychometricFooter from '../psychometric/PsychometricFooter';


const ContactUs = props => {

    const SITE_KEY = '6Lf9udAZAAAAAEFcvREE_07C1AX8HQynYoiZCZzQ';

    // contexts
    const { theme, fontFamily, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [contactus, setContactus] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    //refs
    const recaptchaRef = useRef(null);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById("name").focus();
    }, []);

    // handle functions
    const handleChange = e => {
        try {
            setContactus({ ...contactus, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General ContactUs handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const { name, email, message, token } = contactus;

            if (token) {
                GeneralService.contactUs(name, email, message, token)
                    .then(data => {
                        // to be done - Done
                        Alert.info(data.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                    })
                    .then(data => {
                        recaptchaRef.current.reset();
                        setContactus({
                            name: "",
                            email: "",
                            message: ""
                        });
                        setIsLoading(false);
                        props.history.push('/');
                    })
            } else {
                Alert.error("Please verify captcha", {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading(false);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at General ContactUs handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    //utility function
    const onChangeCaptcha = (value) => {
        try {
            setContactus({ ...contactus, token: value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General ContactUs onChangeCaptcha', 'Error in try catch block', err.stack);
        }
    }

    return (
        <div className="contactusMainDiv" style={{ fontFamily: fontFamily.primary }}>
            <ErrorBoundary errorAt="At General ContactUs GeneralNavbar">
                <PsychometricTestMainNavbar />
            </ErrorBoundary>

            <div className="row p-3 px-5" style={{ background: "rgba(184, 247, 255, 0.3)" }}>
                <div className="col-md-8 col-12 mt-5">
                    <h1 id="contact-us-heading" className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>Contact us</h1>
                    <p id="desc-para" style={{ fontSize: "1.2rem" }}>Contact us with your questions and feedback.</p>
                </div>
                <img className="col-md-4 col-12" src={ContactUsImg} alt="img" />
            </div>


            <div className="mb-5 py-5 col-md-8 mt-5 offset-md-2" style={theme.form}>
                <ErrorBoundary errorAt="At General ContactUs Form">
                    <form className="contactusForm" onSubmit={handleSubmit}>
                        <h2 id="contact-us-form-title" className="formTitle text-center">Send us your Queries</h2>
                        <br />

                        <label htmlFor="name" style={theme.formBodyText} >Name </label>
                        <input type="text"
                            id="name"
                            name="name"
                            value={contactus.name}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <label htmlFor="email" style={theme.formBodyText} >Email </label>
                        <input type="text"
                            id="email"
                            name="email"
                            value={contactus.email}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />


                        <label htmlFor="message" style={theme.formBodyText} >Message </label>
                        <textarea
                            id="message"
                            rows="10"
                            name="message"
                            value={contactus.message}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <ReCAPTCHA
                            id="recaptcha"
                            ref={recaptchaRef}
                            sitekey={SITE_KEY}
                            onChange={onChangeCaptcha}
                        />

                        <button className="btn mx-auto mt-3" id="submit-btn" type="submit" style={theme.button} disabled={isLoading}>
                            {isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit
                        </button>

                        <p id="note-para" className="mt-3" style={theme.paragraphMDSM}>*Note: We will get back to you within 2 business days</p>

                    </form>
                </ErrorBoundary>

            </div>
            <PsychometricFooter />
        </div>
    )

}

export default ContactUs;